import React from "react";
import { useContext } from "react";

export type DashboardError = { title: string; text: string | JSX.Element };

export const ErrorContext = React.createContext({
	error: null as DashboardError | null,
	setError: (error: DashboardError | null) => {},
});

export function useError() {
	return useContext(ErrorContext);
}
